import React from "react"

import { FilterChip } from "@/components/common/Filters"
import type { PriceChangeFilterInput } from "@/graphql/codegen/graphql"
import { useCustomersLookup } from "@/screens/Pricing/hooks/useCustomerLookup.ts"

interface CustomerFilterChipsProps {
  selectedCustomerIds: string[]
  onRemove: (key: keyof PriceChangeFilterInput, value?: string) => void
}

const CustomerFilterChips: React.FC<CustomerFilterChipsProps> = ({ selectedCustomerIds, onRemove }) => {
  const { customers } = useCustomersLookup({ companyIds: selectedCustomerIds })

  return (
    <>
      {customers.map((customer) => (
        <FilterChip
          key={`pricing.filter-chips-${customer.id}`}
          label={`Customer: ${customer.label}`}
          onDelete={() => onRemove("customerIds", customer.id)}
        />
      ))}
    </>
  )
}

export default CustomerFilterChips
